import axios from 'axios';
import { BACKEND_URL } from '../utils/backendUrl';

const API_BASE = `${BACKEND_URL}/api/auth`;

// Create axios instance for auth
const authAxios = axios.create({
  baseURL: API_BASE,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Auth API endpoints for Phase 3
export const authApi = {
  // Authentication endpoints
  login: async (credentials) => {
    const response = await authAxios.post('/login', credentials);
    return response.data;
  },

  sendOtp: async (data) => {
    const response = await authAxios.post('/otp/send', data);
    return response.data;
  },

  verifyOtp: async (data) => {
    const response = await authAxios.post('/otp/verify', data);
    return response.data;
  },

  forgotPassword: async (data) => {
    const response = await authAxios.post('/password/forgot', data);
    return response.data;
  },

  resetPassword: async (data) => {
    const response = await authAxios.post('/password/reset', data);
    return response.data;
  },

  getSession: async (token) => {
    const response = await authAxios.get('/session', {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  },

  refreshToken: async (refreshToken) => {
    const response = await authAxios.post('/refresh', null, {
      params: { refresh_token: refreshToken }
    });
    return response.data;
  },

  logout: async (token) => {
    const response = await authAxios.post('/logout', {}, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  },

  // Demo login endpoint for UAT testing (no OTP, 72h token validity)
  demoLogin: async (credentials) => {
    const response = await authAxios.post('/demo-login', credentials);
    return response.data;
  },

  // Demo health check endpoint
  demoHealth: async () => {
    const response = await authAxios.get('/demo-health');
    return response.data;
  }
};

export default authApi;